import { fromZonedTime, toZonedTime } from "date-fns-tz";

/**
 */
export function localToUTC(localDateTime: string, tz?: string): Date {
  const timezone = tz || Intl.DateTimeFormat().resolvedOptions().timeZone;
  return fromZonedTime(localDateTime, timezone);
}

/**
 */
export function utcToLocal(utcDate: Date | string, tz?: string): Date {
  const timezone = tz || Intl.DateTimeFormat().resolvedOptions().timeZone;
  return toZonedTime(new Date(utcDate), timezone);
}
